import { useEffect } from 'react';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

export default function OfferteAnfordern() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Offerte anfordern | Umzug Schweiz Deutschland"
        description="Kostenlose Offerte für Ihren Umzug von der Schweiz nach Deutschland anfordern. Fixpreis-Garantie, Zollabwicklung inklusive. Antwort innerhalb 24 Stunden."
        keywords="Offerte Umzug, Umzug Offerte, Kostenvoranschlag Umzug, Umzugskosten, Fixpreis Umzug"
        canonical="https://www.umzug-schweiz-deutschland.ch/offerte-anfordern"
        ogImage="https://www.umzug-schweiz-deutschland.ch/umzugsunternehmen-schweiz-deutschland.jpeg"
      />

      <Contact />
    </div>
  );
}
